module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<tr>\n    <td class=\'spending-budget-item\'>\n        <a href="' +
((__t = (window.URLSchemeHandlerInstance.linkToBudget(budget_code,report_year) )) == null ? '' : __t) +
'">\n            ' +
((__t = (budget_code.slice(2) )) == null ? '' : __t) +
' - ' +
((__t = (budget_title )) == null ? '' : __t) +
'\n        </a>\n    </td>\n    <td>\n        ' +
((__t = (report_year )) == null ? '' : __t) +
'/' +
((__t = (report_period ? report_period : '*' )) == null ? '' : __t) +
'\n    </td>\n    <td class=\'spending-supplier\'>\n        ';
 if ( entity_id != null ) { ;
__p += '\n             <a href="' +
((__t = ( window.URLSchemeHandlerInstance.linkToEntity(entity_id) )) == null ? '' : __t) +
'">' +
((__t = (supplier_name )) == null ? '' : __t) +
'</a>\n        ';
 } else { ;
__p += '\n            ' +
((__t = (supplier_name )) == null ? '' : __t) +
'\n        ';
 } ;
__p += '\n    </td>\n    <td class=\'spending-volume\'>' +
((__t = ( volume == null ? 'לא ידוע' : (number_with_commas(volume==null? 0 : volume) +'&nbsp;'+ currency) )) == null ? '' : __t) +
'</td>\n    <td class=\'spending-volume\'>' +
((__t = ( executed == null ? 'לא ידוע' : (number_with_commas(executed==null? 0 : executed) +'&nbsp; ILS') )) == null ? '' : __t) +
'</td>\n    <td class=\'spending-order-date\'>' +
((__t = ( order_date )) == null ? '' : __t) +
'</td>\n    <td class=\'exemption-start\'>' +
((__t = ( purchase_method )) == null ? '' : __t) +
'</td>\n    <td class=\'exemption-start\'>' +
((__t = ( purpose )) == null ? '' : __t) +
'</td>\n</tr>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/single-spending-item.html
// module id = 142
// module chunks = 0